import React, { useEffect, useState } from 'react';
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import CircularProgress from "@mui/material/CircularProgress";
import SearchIcon from '@mui/icons-material/Search';
import CancelIcon from '@mui/icons-material/Cancel';
import { searchStyleInput, searchStyleTextField } from '../SearchBar.style';
import { colorPalette } from '../../../colorPalette';
export const InputSearch = ({ params, dataQa, placeHolder, datas: { searchText, setSearchText, onSearchData }, loading, className, classNameInput, sxInput, hasIconCancel, refreshCancel, noAutocomplete = true, sx, isDynamicSearch }) => {
    const [isDynamicSearchLoading, setIsDynamicSearchLoading] = useState(false);
    const [hasBeenModified, setHasBeenModified] = useState(false);
    useEffect(() => {
        if (isDynamicSearch) {
            if (searchText !== '') {
                setIsDynamicSearchLoading(true);
                const timer = setTimeout(() => {
                    onSearchData(searchText);
                    setIsDynamicSearchLoading(false);
                    setHasBeenModified(true);
                }, 1600);
                return () => clearTimeout(timer);
            }
            else if (searchText === '' && hasBeenModified) {
                handleReset();
                setIsDynamicSearchLoading(false);
            }
        }
    }, [searchText]);
    const handleChange = (event) => {
        setSearchText(event.target.value);
    };
    const keyPressEnter = (e) => {
        if (e.key === 'Enter') {
            onSearchData(searchText);
        }
    };
    const handleReset = () => {
        setSearchText('');
        if (refreshCancel) {
            onSearchData('');
        }
        setHasBeenModified(false);
    };
    return (React.createElement(TextField, Object.assign({}, params, { className: className, sx: searchStyleTextField(sx), placeholder: placeHolder, "data-qa": `${dataQa}-search`, hiddenLabel: true, value: searchText, onChange: handleChange, onKeyPress: !isDynamicSearch ? keyPressEnter : undefined, InputProps: Object.assign(Object.assign({}, params === null || params === void 0 ? void 0 : params.InputProps), { className: classNameInput, sx: searchStyleInput(sxInput, noAutocomplete), startAdornment: (React.createElement(React.Fragment, null, React.createElement(SearchIcon, { sx: { color: colorPalette.gray700, 'margin-right': '8px' } }))), endAdornment: (React.createElement(React.Fragment, null,
                (loading || isDynamicSearchLoading) &&
                    React.createElement(CircularProgress, { color: "inherit", size: 20 }),
                (!loading && !isDynamicSearchLoading) && searchText && hasIconCancel &&
                    React.createElement(InputAdornment, { position: "end", onClick: handleReset },
                        React.createElement(CancelIcon, { "data-qa": `${dataQa}-searchCancelIcon`, sx: { height: '18px', cursor: 'pointer' } })))) }), variant: "filled", type: "search" })));
};
